import { createFileRoute } from '@tanstack/react-router'

import { AssetLibrary } from '@/pages/AssetLibrary/AssetLibrary'

export const Route = createFileRoute('/_app/asset-library/')({
  component: AssetLibrary,
})
